// // src/components/ForgotPassword.jsx
// import React, { useState } from "react";
// import "../CSS/forgotPassword.css";

// const ForgetPassword = () => {
//   const [email, setEmail] = useState("");
//   const [submitted, setSubmitted] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (email.trim()) {
//       setSubmitted(true);
//       // You can connect API call here
//     }
//   };

//   return (
//     <div className="forgot-container">
//       <div className="forgot-card">
//         <h2 className="forgot-title">Forgot Password</h2>
//         <p className="forgot-subtitle">
//           Enter your registered email to reset your password
//         </p>

//         {!submitted ? (
//           <form onSubmit={handleSubmit} className="forgot-form">
//             <div className="input-group">
//               <label htmlFor="email">Email Address</label>
//               <input
//                 type="email"
//                 id="email"
//                 placeholder="Enter your email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>

//             <button type="submit" className="btn-submit">
//               Send Reset Link
//             </button>
//              <a href="/login" className="back-link">&lt; Back to Login</a>
//           </form>
//         ) : (
//           <p className="success-msg">
//              Reset link sent to <strong>{email}</strong>
//           </p>
//         )}

//       </div>

//     </div>
//   );
// };

// export default ForgetPassword;
// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import axios from "axios";
// import "../CSS/forgotPassword.css";

// const ForgetPassword = () => {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post("/api/forgot-password", { email });
//       Swal.fire({
//         title: "Email Sent!",
//         text: `Reset link sent to ${email}`,
//         icon: "success",
//         confirmButtonColor: "#ff8906",
//       });
//       setEmail("");
//     } catch (error) {
//       Swal.fire({
//         title: "Error",
//         text: error.response?.data?.detail || "Failed to send email.",
//         icon: "error",
//         confirmButtonColor: "#e53170",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="forgot-container">
//       <div className="forgot-card">
//         <h2 className="forgot-title">Forgot Password</h2>
//         <p className="forgot-subtitle">
//           Enter your registered email to reset your password
//         </p>

//         <form onSubmit={handleSubmit} className="forgot-form">
//           <div className="input-group">
//             <label htmlFor="email">Email Address</label>
//             <input
//               type="email"
//               id="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <button type="submit" className="btn-submit" disabled={loading}>
//             {loading ? "Sending..." : "Send Reset Link"}
//           </button>
//           <a href="/login" className="back-link">
//             &lt; Back to Login
//           </a>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ForgetPassword;
import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import "../CSS/forgotPassword.css";
import { BASE_API_URL } from "../constants";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      //  Send FormData (not JSON)
      const formData = new FormData();
      formData.append("email", email);

      await axios.post(`${BASE_API_URL}/api/forgot-password`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire({
        title: "Email Sent! ",
        text: `Reset link sent to ${email}`,
        icon: "success",
        confirmButtonColor: "#ff8906",
      });
      setEmail("");
    } catch (error) {
      Swal.fire({
        title: "Error ",
        text: error.response?.data?.detail || "Failed to send email.",
        icon: "error",
        confirmButtonColor: "#e53170",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <h2 className="forgot-title">Forgot Password</h2>
        <p className="forgot-subtitle">
          Enter your registered email to reset your password
        </p>

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="input-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <a href="/login" className="back-link">
            &lt; Back to Login
          </a>
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;
